import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalTotalAgrupadoCfop } from '@/features/relatorio/page/fiscal/total-agrupado-cfop/RelatorioFiscalTotalAgrupadoCfop';

export const Route = createFileRoute('/a/relatorio/fiscal/total-agrupado-cfop')({
    component: RelatorioFiscalTotalAgrupadoCfop,
});
